var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 10.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.5, -10.5)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(10.5 10.5)",
    fill: "#dae0e7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.355 4.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    transform: "translate(-0.356 -0.355)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.718 10.755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.784-33.69v14.1H-22.391v-14.1H1.784m0-2.015H-22.391a2.015,2.015,0,0,0-2.015,2.015v14.1a2.015,2.015,0,0,0,2.015,2.015H1.784A2.014,2.014,0,0,0,3.8-19.588v-14.1a2.014,2.014,0,0,0-2.015-2.015Z",
    transform: "translate(24.406 35.705)",
    fill: "#0d1c4b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.154 8.117)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(-0.228 -0.227)",
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.722 8.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.015,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.864 3.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    transform: "translate(0.063 0.128)",
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.535 4.029)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.015,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.908 4.029)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.015,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.282 4.029)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.015,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.656 4.029)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.015,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.444 3.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 3,
    transform: "translate(0.483 0.128)",
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.348 8.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.828,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.03 8.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.828,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.348 12.088)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.828,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.03 12.088)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.828,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.433 12.088)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.34,
    height: 2.015,
    fill: "#0d1c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.433 8.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.015,
    height: 2.015,
    fill: "#0d1c4b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.712496753ae558b7e23f0ab868c21afd.svg";
export { ForwardRef as ReactComponent };